<template>
  <div class="error-container">
    <span class="code">{{ $t('message.errores.401.codigo') }}</span
    >{{ $t('message.errores.401.detalle') }}
    <p class="small">{{ $t('message.errores.redireccion') }}</p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.redirect();
  },
  methods: {
    redirect() {
      setTimeout(() => {
        this.$router.push({ name: 'login' });
      }, 5000);
    }
  }
};
</script>
